import { useSelector } from 'react-redux';
import { getSplitStatus } from '../reducers/selectors';

const useSplits = splitIdentifiers => {
  const splits = useSelector(state => state.split);
  return getSplitStatus(splits, splitIdentifiers);
};

export default useSplits;
